import dayjs from 'dayjs'
import { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import MovingPrice from '../../../components/v2/MovingPrice'
import PromoCodesInput from '../../../components/v2/PromoCodesInput'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import Accordion from '../../../components/v2/accordions/Accordion'
import Checkbox from '../../../components/v2/buttons/Checkbox'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import DialogModal from '../../../components/v2/modals/DialogModal'
import WelcomerProgressbar from '../../../components/v2/progrees-bars/WelcomerProgressbar'
import { currencySymbol } from '../../../domain/types'
import { RootState, useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import { AuthState } from '../../../store/authSlice'
import {
  WelcomerState,
  setDiscountUsedSuccessfully,
  setInsurerInfo,
  setOfferTotalPrice,
  setPromoCode,
  setPromoCodeValue,
} from '../../../store/welcomerSlice'
import React from 'react'

const WelcomerCheckInformation = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useDispatch()
  //
  const { filter, screenHeader, checkout } = useAppSelector((data: { welcomer: WelcomerState }) => data.welcomer)
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetWelcomerPagesInfoQuery('welcomer-check-info')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  //
  const { data: productCategories, isLoading: isProductCategoryLoading } =
    api.useGetProductCategoriesListQuery(undefined)
  //
  const categoryId = productCategories?.find((x) => x.slug === 'welcomer-to-georgia')?.id || 0
  //
  const { data: informationsheetlist, isLoading: isInformationSheetListLoading } = api.useGetInformationSheetQuery({
    categoryId: categoryId,
    attachmentSlug: 'information-sheet',
  })
  //
  const itemID = informationsheetlist?.find((x) => x.productCategoryId === categoryId)?.id || 0
  //
  const { data: currentInformationSheet, isLoading: isCurrentInformationSheetLoading } =
    api.useGetInformationSheetDetailQuery(itemID, {
      skip: !itemID && true,
    })
  //
  const [franiTermsModalIsOpen, setFraniTermsModalIsOpen] = useState<boolean>(false)
  //
  //
  const closeFraniTermsModal = () => {
    setFraniTermsModalIsOpen(false)
  }
  //
  //
  const [inurerCompanuTermsModalIsOpen, setFnurerCompanuTermsModalIsOpen] = useState<boolean>(false)
  //
  //
  const closeInsurerCompanyModal = () => {
    setFnurerCompanuTermsModalIsOpen(false)
  }
  //
  //
  const [isOpen] = useState<boolean>(false)
  //
  //
  // countries array from api
  const { data: countries, isLoading: isCountriesLoading } = api.useGetCountriesQuery(undefined)
  //
  const [
    welcomerDiscount,
    { isLoading: isWelcomerDiscountLoading, data: discountedPrice, isError: discountError, isSuccess: discountSuccess },
  ] = api.useGetWelcomerPaymentDiscountMutation()
  //
  //
  const CheckboxText =
    t('iReadAndAgree') +
    ' ' +
    filter?.offer?.welcomerPackage?.mainPackage?.product?.company?.brandName?.[lang]?.title +
    `${lang === 'ge' ? ' - ს' : "'s"} ` +
    t('insuranceCondition')
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.singleDates?.start) {
      navigate('/welcomer-start-date')
    }
    //
    return () => {}
  }, [filter.singleDates?.start, navigate])
  //
  const parsedWordingFileUrl = filter?.offer?.welcomerPackage?.mainPackage?.product?.wordingFileUrl?.includes(
    'translations',
  )
    ? JSON.parse(filter?.offer?.welcomerPackage?.mainPackage?.product?.wordingFileUrl)
    : ''
  //
  const discountCallBack = useCallback(async () => {
    // addons
    const attachedAddons = (filter.attachedAddons || []).map((item) => ({
      id: item.addon.id,
      travelersCount: item.count,
      groupedId: null,
    }))
    //
    const groupedAttachedAddons = (filter.groupedAttachedAddons || []).map((item) => ({
      id: null,
      travelersCount: item.count,
      groupedId: item.addon.id,
    }))
    //
    const combinedAddons = [...attachedAddons, ...groupedAttachedAddons]
    //
    // welcomers date by insurer
    const welcomersAge =
      checkout?.forWho === 'me-and-other'
        ? checkout.welcomers
            ?.map((welcomer) =>
              filter.welcomersDate?.find((x) => x?.date === (welcomer?.dateOfbirth as any)?.split('-')?.[0]),
            )
            ?.map((item) => (item?.month === null ? item?.age : 0))
        : filter.welcomersDate?.map((t) => (t?.month === null ? t?.age : 0))
    //
    //
    if (
      filter?.insuranceDays &&
      filter?.currencyId &&
      filter?.limitId &&
      filter?.offer &&
      filter.welcomersDate &&
      filter?.singleDates?.start &&
      filter?.singleDates?.end &&
      filter.promoCode
    ) {
      try {
        //
        await welcomerDiscount({
          promoCode: filter.promoCode || '',
          days: filter?.insuranceDays,
          currencyId: filter?.currencyId,
          limitId: filter?.limitId,
          packageId: filter?.offer?.welcomerPackage?.mainPackage?.id,
          ages: welcomersAge || [],
          startDate: filter?.singleDates?.start as string,
          endDate: filter?.singleDates?.end as string,
          userId: auth?.user?.id ? auth?.user?.id : null,
          selectedCoverages: combinedAddons || [],
        }).unwrap()
        //
      } catch (error: any) {
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0]
          const errorMessage = firstError.message
          toast.error(errorMessage, { toastId: 'some-id-here' })
          //
          dispatch(setPromoCode(''))
        } else {
          toast.error(`${t('promoCodeCantbeUsed')}`)
          dispatch(setPromoCode(''))
        }
      }
    }
    //
  }, [
    t,
    welcomerDiscount,
    filter?.insuranceDays,
    filter?.currencyId,
    filter?.limitId,
    filter?.offer,
    filter.welcomersDate,
    filter?.singleDates?.start,
    filter?.singleDates?.end,
    filter.promoCode,
    auth?.user?.id,
    filter.attachedAddons,
    filter.groupedAttachedAddons,
    checkout.forWho,
    checkout.welcomers,
    dispatch,
  ])
  //
  useEffect(() => {
    //
    discountCallBack()
    //
  }, [discountCallBack])
  //
  useEffect(() => {
    if (discountedPrice !== undefined) {
      dispatch(setDiscountUsedSuccessfully(true))
    } else {
      dispatch(setDiscountUsedSuccessfully(false))
    }
  }, [discountedPrice, dispatch])
  //
  // attached Addons Calculate the total price
  const atAddonsOnceTotalPrice =
    filter.attachedAddons && filter.attachedAddons.length >= 1
      ? filter.attachedAddons
          .filter((x) => x.addon.paymentType === 'ONCE')
          ?.reduce((accumulator, item) => accumulator + parseInt(item.addon.premium, 10) * item.count, 0)
      : 0
  //
  const atAddonsDailyTotalPrice =
    filter.attachedAddons && filter.attachedAddons.length >= 1
      ? filter.attachedAddons
          ?.filter((x) => x.addon.paymentType === 'DAILY')
          ?.reduce(
            (accumulator, item) =>
              accumulator + parseInt(item.addon.premium, 10) * (filter?.insuranceDays || 0) * item.count,
            0,
          )
      : 0
  //
  // groupe dAttached Addons Addons Calculate the total price
  const groupOnceAddonsTotalPrice =
    filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1
      ? filter.groupedAttachedAddons
          ?.filter((x) => x.addon.paymentType === 'ONCE')
          ?.reduce((accumulator, item) => accumulator + item.addon.premium * item.count, 0)
      : 0
  //
  const groupDailyAddonsTotalPrice =
    filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1
      ? filter.groupedAttachedAddons
          ?.filter((x) => x.addon.paymentType === 'DAILY')
          ?.reduce(
            (accumulator, item) => accumulator + item.addon.premium * (filter?.insuranceDays || 0) * item.count,
            0,
          )
      : 0
  //
  const allAddonPrice =
    atAddonsOnceTotalPrice + groupOnceAddonsTotalPrice + atAddonsDailyTotalPrice + groupDailyAddonsTotalPrice
  //
  useEffect(() => {
    //
    const fullPrice =
      filter?.allPrices && filter.insuranceDays
        ? filter?.allPrices?.map((x) => x).reduce((sum, premium) => sum + Number(premium), 0) * filter.insuranceDays +
          allAddonPrice
        : 0
    //
    const discountedFullPrice =
      filter.discountUsedSuccessfully && discountedPrice ? Number(discountedPrice.discounted) : 0

    if (filter?.allPrices && fullPrice && !filter.discountUsedSuccessfully) {
      dispatch(setOfferTotalPrice(fullPrice))
    } else {
      dispatch(setOfferTotalPrice(discountedFullPrice))
    }
    //
    return () => {}
  }, [
    allAddonPrice,
    filter?.allPrices,
    dispatch,
    filter.insuranceDays,
    discountedPrice,
    filter.discountUsedSuccessfully,
  ])
  const MainLoading =
    isCountriesLoading ||
    isPageInfoLoading ||
    isProductCategoryLoading ||
    isInformationSheetListLoading ||
    isCurrentInformationSheetLoading ||
    isWelcomerDiscountLoading
  //

  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      {/* frani terms modal */}
      <DialogModal
        title={`${t('franiConditions')}`}
        isOpen={franiTermsModalIsOpen}
        onClose={closeFraniTermsModal}
        src={currentInformationSheet?.attachment?.[lang]?.url}
        isPdf={true}
        acceptOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'privacyTerm',
              fieldValue: true,
            }),
          ),
          closeFraniTermsModal(),
        ]}
        //
        declineOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'privacyTerm',
              fieldValue: false,
            }),
          ),
          closeFraniTermsModal(),
        ]}
      />
      {/* frani terms modal */}

      {/* insurance company terms */}
      <DialogModal
        title={CheckboxText}
        isOpen={inurerCompanuTermsModalIsOpen}
        onClose={closeInsurerCompanyModal}
        src={
          filter?.offer?.welcomerPackage?.mainPackage?.wordingFiles?.translations?.[lang]?.url ??
          parsedWordingFileUrl?.translations?.[lang]?.url
        }
        isPdf={true}
        acceptOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'policyTerm',
              fieldValue: true,
            }),
          ),
          closeInsurerCompanyModal(),
        ]}
        //
        declineOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'policyTerm',
              fieldValue: false,
            }),
          ),
          closeInsurerCompanyModal(),
        ]}
      />
      {/* insurance company terms */}

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <WelcomerProgressbar stepName={stepName} />

        <MovingPrice price={filter.offerTotalPrice} />
        {/*  */}
        {/*  */}
        {/*  */}
        {/* BEGIN WELCOMERS INFO */}
        {checkout.forWho && checkout.forWho !== 'for-me' ? (
          <WelcomersBlock>
            {checkout.welcomers?.map((welcomer, welcomerIndex) => {
              return (
                <Accordion
                  key={welcomerIndex}
                  isOpen={false}
                  editBtnOnchange={() => {
                    if (checkout.forWho === 'for-other') {
                      return navigate('/welcomer-for-other')
                    }
                    //
                    if (checkout.forWho === 'me-and-other') {
                      return navigate('/welcomer-for-me-and-other')
                    }
                  }}
                  editBtnText={t('edit')}
                  title={` ${
                    welcomerIndex === 0 && checkout.forWho === 'me-and-other'
                      ? `${t('insurerInformation')}`
                      : `${t('traveller')}`
                  }  ${welcomerIndex >= 1 ? welcomerIndex + 1 : ''}`}
                >
                  <TextDiv>
                    <LeftText>{t('cityzenship')}</LeftText>
                    <RightText>
                      {countries?.find((x) => x.isoCode === welcomer?.cityzenship)?.translations?.[lang]?.name}
                    </RightText>
                  </TextDiv>
                  {welcomer?.passportNumber && (
                    <TextDiv>
                      <LeftText>{t('passportNumber')}</LeftText>
                      <RightText>{welcomer?.passportNumber}</RightText>
                    </TextDiv>
                  )}
                  {welcomer?.idNumber && (
                    <TextDiv>
                      <LeftText>{t('personalNumber')}</LeftText>
                      <RightText>{welcomer?.idNumber}</RightText>
                    </TextDiv>
                  )}
                  <TextDiv>
                    <LeftText>{t('dateOfBirth')}</LeftText>
                    <RightText>{welcomer?.dateOfbirth?.toString()?.replace(/\s/g, ' ')?.split('-')[0]}</RightText>
                  </TextDiv>
                  {welcomer?.translations?.ge?.firstName && (
                    <TextDiv>
                      <LeftText>{t('nameInGeorgia')}</LeftText>
                      <RightText>{welcomer?.translations?.ge?.firstName}</RightText>
                    </TextDiv>
                  )}
                  {welcomer?.translations?.ge?.lastName && (
                    <TextDiv>
                      <LeftText>{t('surnameInGeorgia')}</LeftText>
                      <RightText>{welcomer?.translations?.ge?.lastName}</RightText>
                    </TextDiv>
                  )}
                  <TextDiv>
                    <LeftText>{t('nameInEnglish')}</LeftText>
                    <RightText>{welcomer?.translations?.en?.firstName}</RightText>
                  </TextDiv>
                  <TextDiv>
                    <LeftText>{t('surnameInEnglish')}</LeftText>
                    <RightText>{welcomer?.translations?.en?.lastName}</RightText>
                  </TextDiv>
                  <TextDiv>
                    <LeftText>{t('gender')}</LeftText>
                    <RightText>
                      {welcomer.gender === 'female' && `${t('female')}`}
                      {welcomer.gender === 'male' && `${t('male')}`}
                    </RightText>
                  </TextDiv>
                  {(welcomer.addons && welcomer.addons.length >= 1) ||
                  (welcomer.groupedAddonInfos && welcomer.groupedAddonInfos.length >= 1) ? (
                    <>
                      <hr />
                      {welcomer?.addons?.map((atAddon, atAddonIndex) => (
                        <TextDiv key={atAddonIndex}>
                          <LeftText>{atAddon.addon?.translations?.[lang]?.title}</LeftText>
                          <RightText>
                            {atAddon.paymentType === 'DAILY'
                              ? parseFloat(atAddon.premium) * (filter?.insuranceDays || 0)
                              : parseFloat(atAddon.premium)}{' '}
                            ₾
                          </RightText>
                        </TextDiv>
                      ))}

                      {welcomer?.groupedAddonInfos?.map((groupAtAddon, groupAtAddonIndex) => (
                        <TextDiv key={groupAtAddonIndex}>
                          <LeftText>{groupAtAddon.translations?.[lang]?.title}</LeftText>
                          <RightText>
                            {groupAtAddon.paymentType === 'DAILY'
                              ? groupAtAddon.premium * (filter?.insuranceDays || 0)
                              : groupAtAddon.premium}{' '}
                            ₾
                          </RightText>
                        </TextDiv>
                      ))}
                    </>
                  ) : null}
                </Accordion>
              )
            })}
          </WelcomersBlock>
        ) : null}
        {/* END WELCOMERS INFO */}
        {/*  */}
        {/*  */}
        {/*  */}
        {/* BEGIN FOR ME & FOR OTHER INFO */}
        {checkout.forWho === 'for-me' || checkout.forWho === 'for-other' ? (
          <Block>
            <Accordion
              isOpen={isOpen}
              editBtnOnchange={() => {
                if (checkout.forWho === 'for-me') {
                  return navigate('/welcomer-for-me')
                }
                //
                if (checkout.forWho === 'for-other') {
                  return navigate('/welcomer-insurer')
                }
              }}
              editBtnText={t('edit')}
              title={`${t('yourPersonalInfo')}`}
            >
              <TextDiv>
                <LeftText>{t('cityzenship')}</LeftText>
                <RightText>
                  {countries?.find((x) => x.isoCode === checkout?.insurer?.cityzenship)?.translations?.[lang]?.name}
                </RightText>
              </TextDiv>

              {checkout?.insurer?.passportNumber && (
                <TextDiv>
                  <LeftText>{t('passportNumber')}</LeftText>
                  <RightText>{checkout?.insurer?.passportNumber}</RightText>
                </TextDiv>
              )}

              {checkout?.insurer?.idNumber && (
                <TextDiv>
                  <LeftText>{t('personalNumber')}</LeftText>
                  <RightText>{checkout?.insurer?.idNumber}</RightText>
                </TextDiv>
              )}

              <TextDiv>
                <LeftText>{t('dateOfBirth')}</LeftText>
                <RightText>{checkout?.insurer?.dateOfbirth?.toString()?.replace(/\s/g, ' ')}</RightText>
              </TextDiv>

              {checkout?.insurer?.translations?.ge?.firstName && (
                <TextDiv>
                  <LeftText>{t('nameInGeorgia')}</LeftText>
                  <RightText>{checkout?.insurer?.translations?.ge?.firstName}</RightText>
                </TextDiv>
              )}

              {checkout?.insurer?.translations?.ge?.lastName && (
                <TextDiv>
                  <LeftText>{t('surnameInGeorgia')}</LeftText>
                  <RightText>{checkout?.insurer?.translations?.ge?.lastName}</RightText>
                </TextDiv>
              )}

              <TextDiv>
                <LeftText>{t('nameInEnglish')}</LeftText>
                <RightText>{checkout?.insurer?.translations?.en?.firstName}</RightText>
              </TextDiv>

              <TextDiv>
                <LeftText>{t('surnameInEnglish')}</LeftText>
                <RightText>{checkout?.insurer?.translations?.en?.lastName}</RightText>
              </TextDiv>

              <TextDiv>
                <LeftText>{t('gender')}</LeftText>
                <RightText>
                  {checkout?.insurer.gender === 'female' && `${t('female')}`}
                  {checkout?.insurer.gender === 'male' && `${t('male')}`}
                </RightText>
              </TextDiv>

              {checkout.forWho === 'for-me' ? (
                <>
                  {(filter.attachedAddons && filter.attachedAddons.length >= 1) ||
                  (filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1) ? (
                    <>
                      <hr />
                      {filter.attachedAddons?.map((atAddon, atAddonIndex) => (
                        <TextDiv key={atAddonIndex}>
                          <LeftText>{atAddon.addon?.addon?.translations?.[lang]?.title}</LeftText>
                          <RightText>
                            {atAddon.addon.paymentType === 'DAILY'
                              ? parseFloat(atAddon.addon.premium) * (filter?.insuranceDays || 0)
                              : parseFloat(atAddon.addon.premium)}{' '}
                            ₾
                          </RightText>
                        </TextDiv>
                      ))}

                      {filter?.groupedAttachedAddons?.map((groupAtAddon, groupAtAddonIndex) => (
                        <TextDiv key={groupAtAddonIndex}>
                          <LeftText>{groupAtAddon.addon.translations?.[lang]?.title}</LeftText>
                          <RightText>
                            {groupAtAddon.addon.paymentType === 'DAILY'
                              ? groupAtAddon.addon.premium * (filter?.insuranceDays || 0)
                              : groupAtAddon.addon.premium}{' '}
                            ₾
                          </RightText>
                        </TextDiv>
                      ))}
                    </>
                  ) : null}
                </>
              ) : null}
            </Accordion>
          </Block>
        ) : null}
        {/* END FOR ME & FOR OTHER INFO */}
        {/*  */}
        {/*  */}
        <Block>
          <Accordion
            isOpen={true}
            editBtnOnchange={() => alert('edit btn')}
            editBtnText={t('edit')}
            hideEditBtn={true}
            title={`${t('policyInfo')}`}
            disableEditBtn={true}
          >
            <TextDiv>
              <LeftTextForCompany>{t('insuranceCompany')}</LeftTextForCompany>
              <RightText>
                {filter.offer?.welcomerPackage?.mainPackage?.product?.company?.translations?.[lang]?.title}
              </RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('policyType')}</LeftText>
              <RightText>{lang === 'ge' ? 'ერთჯერადი' : lang === 'en' ? 'single' : ''}</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('numberOfDays')}</LeftText>
              <RightText>
                {filter?.insuranceDays} {t('day')}
              </RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('startDate')}</LeftText>
              <RightText>{dayjs(filter?.singleDates?.start).format('DD  MMMM  YYYY')}</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('endDate')}</LeftText>
              <RightText>{dayjs(filter?.singleDates?.end).format('DD  MMMM  YYYY')}</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('travelArea')}</LeftText>
              <RightText>{lang === 'ge' ? 'საქართველო' : lang === 'en' ? 'georgia' : ''}</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('currency')}</LeftText>
              <RightText>{filter?.currency?.toUpperCase()}</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('limit')}</LeftText>
              <RightText>
                {(filter?.limit ? filter.limit : 10000).toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}{' '}
                {currencySymbol(
                  (filter.offer && filter.offer?.welcomerPackage?.mainPackage?.compensationCurrencies[0].currency) ||
                    'gel',
                )}
              </RightText>
            </TextDiv>

            <hr />

            <PromoCodesInput
              value={filter?.promoCodeValue || ''}
              onChange={(value) => dispatch(setPromoCodeValue(value))}
              onClick={() => {
                if (!filter.discountUsedSuccessfully) {
                  //
                  dispatch(setPromoCode(filter?.promoCodeValue))
                  //
                } else {
                  return [
                    dispatch(setPromoCode('')),
                    dispatch(setPromoCodeValue('')),
                    dispatch(setDiscountUsedSuccessfully(false)),
                  ]
                }
                //
              }}
              buttonSize="medium"
              discountValue={filter.discountUsedSuccessfully ? Number(discountedPrice?.saving) : 0}
              disabled={filter?.promoCode !== '' && filter.discountUsedSuccessfully ? true : false}
              discountUsedSuccesfully={filter.discountUsedSuccessfully ? true : false}
              currency={'gel'}
            />

            <hr />

            <TextDiv style={{ marginTop: '6px' }}>
              <LeftText style={{ color: `${Colors.primaryBlack}` }}>{t('currentPayment')}</LeftText>
              <PriceInfo>
                {discountedPrice && filter.discountUsedSuccessfully && (
                  <DiscountInfo>{discountedPrice?.actual} ₾</DiscountInfo>
                )}

                <PriceText>{filter.offerTotalPrice} ₾</PriceText>
              </PriceInfo>
            </TextDiv>

            <hr />

            <Checkbox
              id="check-information-privacy-terms"
              label={`${t('franiConditions')}`}
              checked={checkout.insurer.privacyTerm || false}
              defaultChecked={checkout.insurer.privacyTerm || false}
              onClick={() => setFraniTermsModalIsOpen(true)}
            />

            <hr />

            <Checkbox
              id="check-information-company-terms"
              label={CheckboxText}
              checked={checkout.insurer.policyTerm || false}
              defaultChecked={checkout.insurer.policyTerm || false}
              onClick={() => setFnurerCompanuTermsModalIsOpen(true)}
            />
          </Accordion>
        </Block>
        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => {
              navigate(
                checkout.forWho === 'for-me'
                  ? '/welcomer-for-me'
                  : checkout.forWho === 'for-other'
                  ? '/welcomer-insurer'
                  : checkout.forWho === 'me-and-other'
                  ? '/welcomer-for-me-and-other'
                  : 'welcomer-for-me',
              )
            }}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={checkout.insurer.policyTerm === true && checkout.insurer.privacyTerm === true ? false : true}
            onClick={() => {
              if (
                filter &&
                filter.promoCodeValue &&
                filter.promoCodeValue.length >= 2 &&
                !discountError &&
                !discountSuccess
              ) {
                toast.info(`${t('pleaseActivatePromoCode')}`)
              } else {
                navigate('/welcomer-policy-registration')
              }
            }}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
//
// styles
const PriceText = styled.span`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  text-decoration: none;
  font-weight: 500;
`
const PriceInfo = styled.span`
  color: ${Colors.primaryBlack};
`
//
const DiscountInfo = styled.span`
  font-size: 14px;
  text-decoration: line-through;
  color: ${Colors.nevadaGrey};
  margin-right: 12px;
`
const RightText = styled.div`
  text-align: right;
`
const LeftText = styled.div`
  width: 55%;
`
const LeftTextForCompany = styled.div``
const TextDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  color: ${Colors.nevadaGrey};
  font-size: 14px;
  &:not(:last-child) {
    margin-bottom: 14px;
  }
`
const Block = styled.div`
  max-width: 464px;
  width: 100%;
  margin-inline: auto;
  margin-top: 32px;

  ${Responsive.mobile} {
    margin-top: 24px;
  }
`
const WelcomersBlock = styled(Block)`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-row-gap: 32px;

  ${Responsive.mobile} {
    grid-row-gap: 24px;
  }
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  ${Responsive.mobile} {
    margin-top: 26px;
    width: 100%;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
//
//
export default WelcomerCheckInformation
